import { createAction } from '@reduxjs/toolkit';

export const resetPostcodeFinder = createAction('resetPostcodeFinder');
